__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/8f7ff88df25051b2cc7f46ba4a46834ea54c938c/_next/";